import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/rootLayout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["useTranslation"] */ "/app/src/app/i18n/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getPromotionData"] */ "/app/src/libs/client/goApi/promotion/getPromotionData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/FooterContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/NotFoundGroupComponent.tsx");
